export const SET_SELECTED_STUDENT = "SET_SELECTED_STUDENT";

export const setSelectedStudent = (id, student) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_STUDENT,
    payload: { id, student },
  });
};
